import Animation from './animation'
import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'
import { interpolate } from 'd3-interpolate'

/*
 * This animation is used when we change the pies displayed. This is similar
 * to a sliding axis or adding/removing a breakdown.
 */
class PieCountAnimation extends Animation {

  constructor (options) {
    super(options)

    if (this.chart.previous) {
      // Two part animation if we're replacing all the pies with new pies (e.g. breakdown add/remove)
      this.twoPart = !this.previous.scalers.x.groupScale.domain().filter(tick => {
        return this.scalers.x.groupScale.domain().includes(tick)
      }).length
    }
  }

  timings () {
    let duration = this.twoPart ? (this.totalDuration / 2) : this.totalDuration

    return {
      duration,
      delay: d => {
        if (this.twoPart) {
          // If the element isn't part of the new domain, it's being removed
          // so no delay. Otherwise, we delay by the duration
          return this.pies.range.map(r => r.id).indexOf(d.rangeId) === -1 ? 0 : duration
        } else {
          // No delay if it's not a split transition
          return 0
        }
      }
    }
  }

  match (serie) {
    if (!this.chart.previous) {
      // not an update
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()

    this.ticks0 = ticks0
    this.ticks1 = ticks1

    return ticks0.length != ticks1.length
  }

  animate (serie, entering, selection, merged, exiting) {
    let arc = this.arc
      , previousPies = this.previousPies
      , timing = this.timing

    exiting.duration(timing.duration)
           .delay(timing.delay)
           .call(this.fadeOut)
           .select(function (d) {
             // Adjust the path
             d3.select(`#${d.pathUid.id}`)
               .transition()
               .duration(timing.duration)
               .attrTween('d', function (d) {
                 let arc = shape.arc()
                   , interpolateInnerRadius = interpolate(previousPies.styles.innerRadius, 0)
                   , interpolateOuterRadius = interpolate(previousPies.styles.outerRadius, 0)
                   , slice = this._current

                 return t => {
                   let inner = interpolateInnerRadius(t)
                     , outer = interpolateOuterRadius(t)

                   return arc.innerRadius(inner)
                             .outerRadius(outer)(slice)
                 }
               })
              return this
           })
           .remove()

    entering.select(d => {
      d3.select(`#${d.pathUid.id}`)
        .each(function () {
          this._current = Object.assign({}, d.slice)
        })
    })

    merged.duration(timing.duration)
          .delay(timing.delay)
          .call(this.fadeIn, this.styles)
          .select(d => {
            // Adjust the path. Don't use `arcTweener` because we don't
            // want to adjust the radius. Start the path with its final radius
            d3.select(`#${d.pathUid.id}`)
              .transition()
               .duration(timing.duration)
               .delay(timing.delay(d))
               .attr('d', function () {
                 return arc(this._current)
               })
          })
  }
}

export default PieCountAnimation
